import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { useSelector } from 'react-redux';
import { loadUser, UserState } from 'redux-oidc';
import dialogEmailOpenSlice from './reducers/dialog/dialogEmailOpenSlice';
import dialogEmailComponentSlice from './reducers/dialog/dialogEmailComponentSlice';
import dialogSmsOpenSlice from './reducers/dialog/dialogSmsOpenSlice';
import dialogSmsComponentSlice from './reducers/dialog/dialogSmsComponentSlice';
import snackBarMessageSlice from '../store/reducers/snackbar/snackBarMessageSlice';
import snackBarOpenSlice from '../store/reducers/snackbar/snackBarOpenSlice';
import snackBarMessageTypeSlice from '../store/reducers/snackbar/snackBarMessageTypeSlice';
import getUserSettingsSlice from '../store/reducers/getUserSettings';
import getUserSlice from '../store/reducers/getUserSlice';
import userTokenSlice from '../store/reducers/userTokenSlice';
import filterDataSlice from '../store/reducers/filterDataSlice';
import currentPageSlice from '../store/reducers/currentPageSlice';
import skipDataSlice from '../store/reducers/skipDataSlice';
import sortedDataSlice from '../store/reducers/sortedDataSlice';
import currentRegionFilterSlice from '../store/reducers/currentRegionFilterSlice';
import currentTerritoryFilterSlice from '../store/reducers/currentTerritoryFilterSlice';
import currentPrincipalFilterSlice from '../store/reducers/currentPrincipalFilterSlice';
import gridSelectionChangesSlice from '../store/reducers/gridSelectionChangesSlice';
import tokenDataVerifierSlice from '../store/reducers/tokenDataVerifierSlice';
import setCurrentPageSlice from '../store/reducers/setCurrentPageSlice';
import emailContentSlice from '../store/reducers/emailContentSlice';
import clearFilterSlice from '../store/reducers/clearFilterSlice';
import serviceTokenSlice from '../store/reducers/serviceTokenSlice';

export const store = configureStore({
 reducer: {
  dialogEmailOpen: dialogEmailOpenSlice,
  dialogEmailComponent: dialogEmailComponentSlice,
  dialogSmsOpen: dialogSmsOpenSlice,
  dialogSmsComponent: dialogSmsComponentSlice,
  snackBarMessage: snackBarMessageSlice,
  snackBarOpen: snackBarOpenSlice,
  snackBarMessageType: snackBarMessageTypeSlice,
  getUserSettings: getUserSettingsSlice,
  getUser: getUserSlice,
  userToken: userTokenSlice,
  filterData: filterDataSlice,
  currentPage: currentPageSlice,
  skipData: skipDataSlice,
  sortedData: sortedDataSlice,
  currentRegionFilter: currentRegionFilterSlice,
  currentTerritoryFilter: currentTerritoryFilterSlice,
  currentPrincipalFilter: currentPrincipalFilterSlice,
  gridSelectionChanges: gridSelectionChangesSlice,
  tokenDataVerifier: tokenDataVerifierSlice,
  setCurrentPage: setCurrentPageSlice,
  emailContent: emailContentSlice,
  clearFilter: clearFilterSlice,
  serviceToken: serviceTokenSlice,
 },
 middleware: (getDefaultMiddleware: any) =>
  getDefaultMiddleware({
   serializableCheck: false,
  }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
